import React from "react";
import HeroImage from "../assets/ethicswala1.webp";
import { FaRegArrowAltCircleRight } from "react-icons/fa";
import Typewriter from "typewriter-effect";
import { Link } from "react-scroll";
import "./socialicons.css";
import { FaFacebookF } from "react-icons/fa";
import { FaTelegramPlane } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";


const Landing = () => {
 

  return (
    <div
      name="landing"
      className="w-full bg-gradient-to-b from-black via-black to-gray-800 h-screen  pt-10"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-3  md:flex-row  ">
        <div className="flex flex-col justify-center h-full  px-3 md:px-3  w-full xl:w-screen">
          <h2 className="text-3xl sm:text-6xl font-bold text-white pb-4  pt-10 ">
            <span className="text-2xl md:text-5xl text-gray-600">
              Hi!
              <br />
              Welcome,To <br/>My World...
            </span>
            <br />
            I'm a
            <Typewriter
              options={{
                strings: [
                  "Web Developer",
                  "Web Designer",
                  "App Designer",
                  "Photo Editor",
                  "Digital Marketer",
                ],
                autoStart: true,
                loop: true,
              }}
            />
          </h2>

          <div>
            <div className="socialmda ">
              <a
                className="socialLink"
                href="https://www.facebook.com/profile.php?id=100064045961582&mibextid=ZbWKwL"
              >
                <FaFacebookF className="icon-btn" />
              </a>
              <a
                className="socialLink"
                href="https://chat.whatsapp.com/JROn4kBqWoPFYsN1mdMHqp"
              >
                <FaWhatsapp className="icon-btn" />
              </a>

              <a
                className="socialLink"
                href="https://t.me/ethicswalacoder_family"
              >
                <FaTelegramPlane className="icon-btn" />
              </a>
              <a
                className="socialLink"
                href="https://twitter.com/i/flow/login?input_flow_data=%7B%22requested_variant%22%3A%22eyJsYW5nIjoiZW4ifQ%3D%3D%22%7D"
              >
                <FaTwitter className="icon-btn" />
              </a>
              <a
                className="socialLink"
                href="https://instagram.com/artbangla_bazaar?igshid=YmMyMTA2M2Y="
              >
                <FaInstagram className="icon-btn" />
              </a>
            </div>
            <Link
              to="portfolio"
              smooth
              duration={500}
              className=" group text-white w-fit px-4 py-2 md:px-6 md:py-3  flex items-center rounded-md
                bg-gradient-to-r from-cyan-500  to-blue-500 cursor-pointer md:my-2 "
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300 ml-2">
                <FaRegArrowAltCircleRight />
              </span>
            </Link>
          </div>
        </div>
        <div >
        
          <img
            src={HeroImage}
            alt=" my profile pic"
            className=" rounded-full   mx-auto  w-2/3 xl:w-11/12  md:w-7/12 lg:w-6/12  "
          />
        </div>
      </div>
    </div>
  );
};

export default Landing;
